import {hasPassedElement} from '../helpers/has-passed-element';
import {breakpoints} from '../helpers/constants';

export class showAfterScroll {

	constructor(elem, options = {}) {
		this.elem = elem;
		this.options = options;

		const selectorForElementToShow = this.elem.dataset.showAfterScroll || '';

		this.elementToShow = document.querySelector(`[data-element-to-show="${selectorForElementToShow}"]`);

		this.elementIsShown;

		if (this.elementToShow) {
			this.init();
		}

	}

	get classNames() {
		return {
			ACTIVE: '_is-active',
			ACTIVEBODY: '_has-active-bar'
		}
	}

	init() {
		this.handlePassedElement();
		this.addEventHandlers();
	}

	addEventHandlers(){
		window.addEventListener('scroll', this.handlePassedElement.bind(this));
	}

	handlePassedElement() {
		if(this.testBreakpoint()){
			if (hasPassedElement(this.elem)) {
				this.elementIsShown = true;
				this.elementToShow.classList.add(this.classNames.ACTIVE);
				document.body.classList.add(this.classNames.ACTIVEBODY);
			} else {
				this.elementIsShown = false;
				this.elementToShow.classList.remove(this.classNames.ACTIVE);
				document.body.classList.remove(this.classNames.ACTIVEBODY);
			}
		}

	}

	testBreakpoint() {
		let result;
		switch(this.options.breakpoint) {
			case 'isMedium':
				result = breakpoints.isMedium();
				break;
			case 'isMediumInverted':
				result = !breakpoints.isMedium();
				break;
			default:
				result = true;
		}
		return result;
	}

	static getSelector() {
		return '[data-show-after-scroll]';
	}

}
